// src/api/token.js

// 쿠키에서 액세스 토큰 읽기
export const getAccessTokenFromCookie = () => {
  const token = document.cookie
    .split('; ')
    .find(row => row.startsWith('access_token='))
    ?.split('=')[1];
  console.log('[token.js] 쿠키에서 accessToken 읽기:', token);
  return token;
};

// 액세스 토큰 저장 및 삭제
export const setAccessTokenToCookie = (token) => {
  if (token) {
    document.cookie = `access_token=${token}; path=/; max-age=3600`;
    console.log('[token.js] 쿠키에 accessToken 저장:', token);
  } else {
    document.cookie = 'access_token=; path=/; max-age=0';
    console.log('[token.js] 쿠키에서 accessToken 삭제');
  }
};
